import React from 'react';
import './loader.css';

const SpinnerLoader = ({ loading }) => {
  return (
    <section
      style={{
        width: '100%',
        height: '100vh',
        background: 'rgba(0,0,0,0.2)',
        position: 'absolute',
        zIndex: 10000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <svg id="c" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill="none"
          strokeWidth="4"
          strokeLinecap="round"
          stroke="#003876"
          cx="45"
          cy="45"
          r="43"
        />
      </svg>
    </section>
  );
};

export default SpinnerLoader;
